var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"billboard"},[_c('div',{staticClass:"billboard__wrapper"},[_c('Column',{attrs:{"align":"center"}},[_vm._t("billboard-title"),_vm._t("billboard-description"),_vm._t("billboard-buttons")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }